<template>
    <div class="content-container">
        <!-- Loading -->
        <div class="loading-state fullscreen" :class="{'overlay': loading}" v-if="loading || loadingColours">
            <loading-state></loading-state>
            <h4 class="text-center" v-if="loadingColours">Loading colours...</h4>
        </div>

        <!-- Content -->
        <div class="content">
            <div class="container h-auto pb-0">
                <div class="row">

                    <!-- Title -->
                    <div class="col-12">
                        <div class="title">
                            <h1>{{ pageTitle }}</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <!-- Screen sizes 576px and above -->
                    <div class="col-12 d-none d-sm-block">
                        <hooper ref="carousel" :settings="hooperSettings">
                            <slide
                                v-for="(modelVersion, index) in modelVersions"
                                :key="modelVersion.id"
                                :initialSlide="initialSlide">
                                <div class="selectable-card"
                                     @click="checkAndSelectModelVersion(modelVersion, index)"
                                     :class="{ active: modelVersionIsActive(modelVersion) }">
                                    <div class="card-body">
                                        <img class="hooper-img device-img" :src="modelVersion.image.path" :alt="modelVersion.title">
                                        <p>
                                            {{ modelVersion.colour }}
                                        </p>
                                    </div>
                                </div>
                            </slide>
                            <hooper-navigation slot="hooper-addons"></hooper-navigation>
                            <hooper-pagination slot="hooper-addons"></hooper-pagination>
                        </hooper>
                    </div>

                    <!-- Screen sizes 575px and below -->
                    <div class="col-12 d-sm-none">
                        <div class="card-grid grid-col-2 row">
                            <div class="selectable-card"
                                 v-for="(modelVersion, index) in modelVersions"
                                 :key="modelVersion.id"
                                 @click="checkAndSelectModelVersion(modelVersion, index)"
                                 :class="{ active: modelVersionIsActive(modelVersion) }">
                                <div class="card-body">
                                    <img class="hooper-img device-img" :src="modelVersion.image.path" :alt="modelVersion.title">
                                    <p>
                                        {{ modelVersion.colour }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Footer -->
            <footer class="footer fixed-footer">
                <div class="container">
                    <router-link :to="{ name: 'deviceModel'}" class="btn btn-outline-secondary back-btn btn-lg"><i class="fa fa-chevron-left text-sm mr-3"></i> Back</router-link>
                    <button @click="saveSelection()" class="btn btn-lg continue-btn icon-right ml-auto" :class="{'disabled': !modelVersionHasBeenSelected || loading}">Next <i class="fa fa-chevron-right ml-3 text-sm"></i></button>
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {
        Hooper,
        Navigation as HooperNavigation,
        Pagination as HooperPagination,
        Slide
    } from 'hooper'; // https://baianat.github.io/hooper/
    import 'hooper/dist/hooper.css';

    export default {
        name: "DeviceColour",

        mounted() {
            this.checkCanBeOnPage();
            this.loadVersions();
            this.$refs.carousel.slideTo(this.initialSlide);
        },

        components: {
            Hooper,
            HooperNavigation,
            HooperPagination,
            Slide
        },

        data() {
            return {
                loading: false,
                loadingColours: true,
                hooperSettings: {
                    centerMode: true,
                    itemsToShow: 1.5,
                    900: {
                        itemsToShow: 3
                    }
                }
            }
        },

        computed: {
            ...mapGetters([
                "activeModelVersionId",
                "allowsInsuranceOrder",
                "isBookingInStore",
                "makeIsSamsung",
                "modelHasBeenSelected",
                "modelVersions",
                "modelVersionHasBeenSelected",
                "modelVersionIsActive",
                "selectedModel"
            ]),

            initialSlide() {
                if (this.activeModelVersionId) {
                    for (let i = 0; i < this.modelVersions.length; i++) {
                        if (this.modelVersions[i].id === this.activeModelVersionId) {
                            return i;
                        }
                    }
                }
                return 0;
            },

            nextStep() {
                if (this.makeIsSamsung) {
                    return "deviceFaultType";
                }
                return (this.allowsInsuranceOrder) ? "deviceInsuranceStatus" : "repairSelect";
            },

            pageTitle() {
                if (this.isBookingInStore) {
                    return "What colour is the " + this.selectedModel.title + "?";
                }

                return "What colour is your " + this.selectedModel.title + "?";
            }
        },

        methods: {
            ...mapActions([
                "checkBookingIsComplete",
                "displayToast",
                "loadModelVersions",
                "selectModelVersion",
                "updateDevice"
            ]),

            /** Select the model version */
            checkAndSelectModelVersion(modelVersion, index) {
                this.selectModelVersion(modelVersion.id);
                this.$refs.carousel.slideTo(index);
            },

            /** Check the user can be on the page */
            checkCanBeOnPage() {
                this.checkBookingIsComplete().then(() => {
                    if (!this.modelHasBeenSelected) {
                        this.$router.push({name: 'deviceModel'});
                    }
                });
            },

            loadVersions() {
                this.loadingColours = true;
                this.loadModelVersions()
                    .then(() => {
                        this.loadingColours = false;
                    }).catch(error => {
                        this.loadingColours = false;
                        this.displayToast({text: error, type: 'error'});
                    })
            },

            saveSelection() {
                this.loading = true;
                this.updateDevice(true).then(() => {
                    this.loading = false;
                    this.$router.push({name: this.nextStep});
                }).catch(() => {
                    this.loading = false;
                });
            }
        }
    };
</script>